/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { FlexColumn, FlexFill, FlexRow } from '../../basic/Flex';
import Label from './Label';
import { InputMessages } from './InputMessage';
import { InfoButton } from "./TooltipButton";
import { useRef } from "react";
import { FormFieldProps } from '@/shared/types/form-field';

export const FieldWrapper: ComponentWithChildren<FormFieldProps> = ({
  name,
  label,
  help,
  children,
  sx,
}) => {
  return (
    <FlexColumn sx={{ ...sx }}>
      {(label || help) && (
        <FlexRow sx={{ alignItems: "center", height: "auto" }}>
          {label && <Label name={name}>{label}</Label>}
          <FlexFill />
          {help && <InfoButton text={help ?? ""} />}
        </FlexRow>
      )}
      {children}
      <InputMessages name={name} />
    </FlexColumn>
  );
};

export const FieldWrapperInline: ComponentWithChildrenFn<
  React.MutableRefObject<HTMLElement | undefined>,
  FormFieldProps
> = ({ name, label, help, sx, children }) => {
  const labelRef = useRef<HTMLElement | undefined>(undefined);
  return (
    <FlexRow className="items-center gap-2" sx={sx}>
      {/* eslint-disable-next-line react-hooks/refs */}
      {typeof children == "function" && children(labelRef)}
      <Label
        name={name}
        sx={{ cursor: "inherit" }}
        onClick={() => labelRef?.current?.click()}
      >
        {label}
      </Label>
    </FlexRow>
  );
};
